import type * as React from 'react';
import { cn } from '../../lib/cn.ts';

export type SkeletonProps = Omit<React.ComponentProps<'span'>, 'style' | 'children'>;

/**
 * The shape of something still on its way. Sized by the caller to stand where
 * the real thing will, so the page does not jump when it arrives.
 */
export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <span
      data-slot='skeleton'
      aria-hidden='true'
      className={cn(
        'block animate-pulse rounded-sm bg-fill motion-reduce:animate-none',
        className,
      )}
      {...props}
    />
  );
}
